export const ru = {
    nav: {
        home: "Главная",
        about: "О нас",
        services: "Услуги",
        contact: "Контакты",
        consultation: "Консультация",
        subTitle: "Law & Consultancy",
        workingHours: "Пн - Пт: 09:00 - 18:00"
    },
    hero: {
        slides: [
            {
                title: "Профессиональные юридические и адвокатские услуги",
                description: "Многолетний практический опыт в области юриспруденции"
            },
            {
                title: "Высококлассное корпоративное обслуживание",
                description: "Предотвращение, выявление и надежное решение правовых задач вашего бизнеса"
            },
            {
                title: "Индивидуальный подход к каждому доверителю",
                description: "Приоритетом для нас являются индивидуальные требования и цели каждого клиента"
            }
        ],
        btnConsultation: "Консультация",
        btnServices: "Услуги",
        stats: {
            yearsExp: "Лет опыта",
            cases: "Судебных дел",
            successRate: "Успешных дел",
            confidentiality: "Конфиденциальность"
        }
    },
    marquee: "Защита ваших прав — наша главная миссия.",
    home: {
        practiceTitle: "Сферы Услуг",
        practiceAreas: [
            {
                title: "Гражданское право",
                description: "Защита ваших прав и законных интересов по любым делам, связанным с частным правом"
            },
            {
                title: "Административное право",
                description: "Ваш надежный правовой защитник во взаимоотношениях с государственными органами."
            },
            {
                title: "Корпоративное право",
                description: "Корпоративное юридическое сопровождение компаний и разрешение любых правовых вопросов"
            }
        ],
        btnMore: "Подробнее",
        whyChooseUs: "Почему выбирают нас",
        learnMore: "Узнать больше",
        ctaTitle: "Готовы обсудить все интересующие вас правовые вопросы",
        ctaText: "Свяжитесь с нашими специалистами сегодня и получите первичную профессиональную консультацию:",
        btnCallNow: "Позвонить сейчас",
        btnSendMessage: "Отправить сообщение",
        toastCallTitle: "Позвоните нам",
        toastCallDesc: "Телефон: +374 77 53 13 09"
    },
    about: {
        pageTitle: "О Компании",
        pageSubtitle: "С 2023 года мы обеспечиваем предоставление профессиональных юридических и адвокатских услуг в сферах частного, административного и корпоративного права.",
        stats: [
            { value: "5+", label: "Лет опыта" },
            { value: "200+", label: "Судебных дел" },
            { value: "94%", label: "Успешных дел" }
        ],
        foundersTitle: "Основатели компании",
        team: [
            {
                name: "Арен Варданович Антонян",
                role: "Соучредитель, адвокат",
                specialization: "Гражданское право, административное право, корпоративное право, банкротство, закупки",
                experience: "5 лет",
                experienceLabel: "Опыт"
            },
            {
                name: "Ашот Арамович Григорян",
                role: "Соучредитель, управляющий директор",
                specialization: "Гражданское право, административное право, корпоративное право, банкротство, право интеллектуальной собственности",
                experience: "5 лет",
                experienceLabel: "Опыт"
            }
        ],
        btnViewDetails: "Посмотреть подробнее",
        historyTitle: "Наша История",
        historyP1: "Компания основана в 2023 году. С первого дня основания наши юристы и адвокаты неизменно защищают права и законные интересы граждан и бизнеса.",
        historyP2: "В результате наши доверители всегда остаются полностью удовлетворены проявленным подходом и полученной правовой поддержкой.",
        historyP3: "Мы остаемся верны нашим ключевым ценностям: справедливость, трудолюбие и персональный подход к каждому.",
        valuesTitle: "Наши Ценности",
        values: [
            {
                title: "Восстановление справедливости",
                description: "Мы боремся во всех судебных инстанциях за защиту прав и законных интересов наших доверителей."
            },
            {
                title: "Профессионализм",
                description: "Мы предлагаем самые оптимальные и перспективные правовые решения."
            },
            {
                title: "Преданность делу",
                description: "Мы сохраняем абсолютную верность принципам и ценностям нашей компании."
            },
            {
                title: "Ответственность",
                description: "Консультация или правовое решение каждого сотрудника компании предоставляется на высочайшем профессиональном уровне."
            }
        ],
        ctaTitle: "Готовы обсудить ваши правовые вопросы",
        ctaText: "Свяжитесь с нашей командой и получите первоклассную правовую помощь:",
        btnContactUs: "Связаться с нами"
    },
    services: {
        pageTitle: "Профессиональные юридические и адвокатские услуги",
        btnViewAll: "Смотреть все услуги",
        items: [
            {
                title: "Юридическая консультация",
                services: [
                    "Предоставление устных юридических консультаций",
                    "Предоставление письменных юридических заключений"
                ]
            },
            {
                title: "Корпоративное право",
                services: [
                    "Учреждение, реорганизация и ликвидация юридических лиц (включая иностранные компании)",
                    "Корпоративное абонентское обслуживание компаний"
                ]
            },
            {
                title: "Договорное право",
                services: [
                    "Ведение переговоров (в том числе с иностранными партнерами)",
                    "Составление и правовой аудит договоров",
                    "Организация нотариального удостоверения сделок"
                ]
            },
            {
                title: "Административное право",
                services: [
                    "Обжалование административных актов (штрафы, пени и санкции)",
                    "Обжалование неправомерных действий и бездействия административных органов"
                ]
            },
            {
                title: "Банкротство",
                services: [
                    "Составление заявлений о добровольном банкротстве",
                    "Составление заявлений о принудительном банкротстве",
                    "Представительство в процедурах банкротства"
                ]
            },
            {
                title: "Трудовое право",
                services: [
                    "Досудебное урегулирование трудовых споров",
                    "Судебное представительство по трудовым спорам"
                ]
            },
            {
                title: "Закупки",
                services: [
                    "Представительство в спорах, связанных с государственными закупками",
                    "Представительство в спорах, связанных с коммерческими тендерами"
                ]
            },
            {
                title: "Страхование",
                services: [
                    "Правовое сопровождение страховых отношений и выплат"
                ]
            },
            {
                title: "Исполнительное производство",
                services: [
                    "Сопровождение исполнительного производства"
                ]
            },
            {
                title: "Арбитражное производство",
                services: [
                    "Представительство в арбитражных судах"
                ]
            },
            {
                title: "Строительство и девелопмент",
                services: [
                    "Правовое сопровождение градостроительной деятельности"
                ]
            },
            {
                title: "Судебное представительство",
                services: [
                    "Представительство по делам о защите права собственности",
                    "Представительство по земельным спорам",
                    "Представительство по защите прав интеллектуальной собственности",
                    "Представительство по семейным спорам",
                    "Представительство по наследственным делам",
                    "Представительство по всем категориям гражданских, административных дел и дел о банкротстве"
                ]
            }
        ]
    },
    connect: {
        heroTitle: "Почему стоит обратиться к нам",
        heroText: "Наша опытная юридическая команда готова оказать вам всестороннюю поддержку, гарантируя конфиденциальность, пунктуальность и постоянную доступность.",
        badgeLawyers: "Опытные юристы",
        badgeFast: "Быстрый отклик",
        badgePrivacy: "100% Конфиденциальность",
        btnSendInquiry: "Отправить запрос",
        formTitle: "Связаться с нами",
        labelName: "Имя",
        placeholderName: "Ваше имя",
        labelLastname: "Фамилия",
        placeholderLastname: "Ваша фамилия",
        labelSurname: "Отчество",
        placeholderSurname: "Ваше отчество",
        labelEmail: "Электронная почта",
        placeholderEmail: "Ваш email",
        labelPhone: "Номер телефона",
        placeholderPhone: "Ваш номер телефона",
        labelMessage: "Ваше сообщение",
        placeholderMessage: "Кратко опишите вашу правовую проблему...",
        btnSubmit: "Отправить сообщение",
        btnSubmitting: "Отправка...",
        toastSuccessTitle: "Сообщение успешно отправлено",
        toastSuccessDesc: "Спасибо! Мы свяжемся с вами в ближайшее время.",
        toastErrorTitle: "Ошибка отправки",
        toastErrorDesc: "Не удалось отправить сообщение. Пожалуйста, попробуйте снова.",
        infoTitle: "Контактная информация",
        addressTitle: "Адрес офиса",
        addressValue: "г. Ереван, ул. Толбухина 34 - перекресток Мамиконянц и Н. Тиграняна",
        btnSeeMap: "Посмотреть на карте",
        phonesTitle: "Телефоны",
        emailTitle: "Электронная почта",
        daysTitle: "Рабочие дни",
        daysValue: "Понедельник - Пятница",
        hoursTitle: "Рабочие часы",
        hoursValue: "09:00 - 18:00"
    },
    modal: {
        mapTitle: "Местонахождение нашего офиса",
        close: "Закрыть",
        experienceClose: "Закрыть"
    },
    testimonials: {
        badge: "ОТЗЫВЫ ДОВЕРИТЕЛЕЙ",
        title: "Что говорят о нас наши клиенты",
        subtitle: "Наш главный успех — это благодарность наших довольных и защищенных доверителей.",
        reviews: [
            {
                quote: "Команда LegalTitan обеспечила надлежащее судебное представительство, в результате которого было восстановлено мое право собственности. Очень благодарна за высокий профессионализм.",
                author: "Анна С.",
                role: "Индивидуальный предприниматель",
                rating: 5
            },
            {
                quote: "Наша компания неоднократно обращалась в ООО «Легал Титан» по вопросам в сфере публичного и налогового права и неизменно получала самые оптимальные правовые решения.",
                author: "Армен К.",
                role: "Директор, строительная компания",
                rating: 5
            },
            {
                quote: "Мы обратились в «Легал Титан» для постоянного сотрудничества в 2023 году и сотрудничаем до сих пор. Все правовые вопросы решаются оперативно и безупречно.",
                author: "Гарик М.",
                role: "Основатель, IT-компания",
                rating: 5
            }
        ]
    },
    footer: {
        description: "Компания оказывает высококлассные юридические и адвокатские услуги, основанные на многолетнем опыте, профессионализме и 100% конфиденциальности.",
        quickLinks: "БЫСТРЫЕ ССЫЛКИ",
        practiceAreas: "СФЕРЫ ПРАВА",
        contactInfo: "КОНТАКТНЫЕ ДАННЫЕ",
        copyright: "LegalTitan LLC. Все права защищены.",
        badgeProtection: "Профессиональная юридическая защита в Армении"
    }
};
